import React, { Component } from 'react'
import StyleSheet from 'styles'
import Typography from '@material-ui/core/Typography'
import Dialog from './Dialog'
import {LinkButton} from 'components'

export class Link extends Component{

  state = { contactUsOpen: false }

  handleDismissDialog = () => {
    this.setState({contactUsOpen: false})
  }

  handleOpenContactUs = () => {
    this.setState({contactUsOpen: true})
  }

  render = () =>
    <div className={this.props.className}>
      <Typography variant='body1' className={styles.contactUsBox}>
        <LinkButton onClick={this.handleOpenContactUs}>Need help? Contact Us!</LinkButton>
      </Typography>
      {Dialog && <Dialog open={this.state.contactUsOpen} onRequestClose={this.handleDismissDialog}/>}
    </div>

}

const styles = StyleSheet({
  contactUsBox: {
    marginTop: 10,
    paddingRight: 10,
    textAlign: 'right'
  }
})

export default Link